import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb89864c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "logistics-search-box" }
const _hoisted_3 = { class: "logistics-search-flex1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "data-contianer" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("发起售后")
const _hoisted_6 = { style: {"margin":"0 8px","font-weight":"normal"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_DefaultOptionSelect = _resolveComponent("DefaultOptionSelect")!
  const _component_FaceSheetReomteSelect = _resolveComponent("FaceSheetReomteSelect")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ReportTable = _resolveComponent("ReportTable")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_AdminTableLayout = _resolveComponent("AdminTableLayout")!
  const _component_OrderTravel = _resolveComponent("OrderTravel")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AdminTableLayout, {
      formData: _ctx.formData,
      formLabelWidth: 100,
      searchDisabled: _ctx.loading,
      onSearch: _ctx.onSearchHandle
    }, {
      "content-header": _withCtx(() => [
        _createVNode(_component_ExportButton, {
          type: "billDetail",
          disabled: _ctx.tableData.length<=0,
          postData: _ctx.postData
        }, null, 8, ["disabled", "postData"])
      ]),
      "search-info": _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_form_item, {
              "label-width": 100,
              label: "按运单号查询",
              prop: "billCodes"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "logistics-search-input",
                  type: "textarea",
                  rows: 3,
                  placeholder: "请输入需要查询的运单号 ，多个运单号用回车键（Enter）隔开",
                  modelValue: _ctx.formData.billCodes,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.billCodes) = $event)),
                  onBlur: _ctx.deleteRepeatOrderNumber
                }, null, 8, ["modelValue", "onBlur"]),
                _createElementVNode("div", {
                  class: "logistics-search-box-clear",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.billCodes = ''))
                }, " 清空 ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_row, { justify: "space-between" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "订单创建时间",
                      prop: "time"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DatePicker, {
                          disabled: !!_ctx.formData.billCodes,
                          type: "daterange",
                          disabledDate: (time) => _ctx.formatThisMonth(time, _ctx.calendarTime),
                          onCalendarChange: _ctx.handleCalendarChange,
                          modelValue: _ctx.formData.time,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.time) = $event))
                        }, null, 8, ["disabled", "disabledDate", "onCalendarChange", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "物流状态",
                      prop: "billStatus"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DefaultOptionSelect, {
                          disabled: !!_ctx.formData.billCodes,
                          "dictionary-key": "bill_list_status_type",
                          "has-all": "",
                          modelValue: _ctx.formData.billStatus,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.billStatus) = $event))
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "电子面单账号",
                      prop: "partnerIds"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FaceSheetReomteSelect, {
                          disabled: !!_ctx.formData.billCodes,
                          "has-all": "",
                          modelValue: _ctx.formData.partnerIds,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.partnerIds) = $event))
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "收件人手机号",
                      prop: "receiveMobile"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: !!_ctx.formData.billCodes,
                          placeholder: "请输入收件人手机号",
                          type: "number",
                          modelValue: _ctx.formData.receiveMobile,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.receiveMobile) = $event))
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "收件人姓名",
                      prop: "receiveName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: !!_ctx.formData.billCodes,
                          placeholder: "请输入收件人姓名",
                          modelValue: _ctx.formData.receiveName,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.receiveName) = $event)),
                          maxlength: 10
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 11 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "发件人姓名",
                      prop: "sendName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: !!_ctx.formData.billCodes,
                          placeholder: "请输入发件人姓名",
                          modelValue: _ctx.formData.sendName,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.sendName) = $event)),
                          maxlength: 10
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      "content-table": _withCtx(() => [
        _hoisted_4,
        _createVNode(_component_ReportTable, {
          loading: _ctx.loading,
          emptyText: "暂无运单",
          tableData: _ctx.tableData,
          showTableColumn: _ctx.showTableColumn
        }, {
          billCode: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              style: {"margin-right":"5px"},
              onClick: ($event: any) => (_ctx.handleClick(row.billCode))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.billCode), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          actions: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              style: {"margin-right":"5px"},
              onClick: ($event: any) => (_ctx.handleAfterSales(row))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["loading", "tableData", "showTableColumn"])
      ]),
      "foot-pagination": _withCtx(() => [
        _createVNode(_component_el_pagination, {
          class: "system-pagination",
          layout: "sizes, prev, slot, next",
          total: _ctx.totalNum,
          "page-sizes": _ctx.pageSizeList,
          "current-page": _ctx.pageNum,
          "onUpdate:current-page": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:page-size": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pageSize) = $event)),
          onCurrentChange: _ctx.currentPageChangeHandle,
          onSizeChange: _ctx.sizeChangeHandle
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, "第 " + _toDisplayString(_ctx.pageNum) + " 页", 1)
          ]),
          _: 1
        }, 8, ["total", "page-sizes", "current-page", "page-size", "onCurrentChange", "onSizeChange"])
      ]),
      _: 1
    }, 8, ["formData", "searchDisabled", "onSearch"]),
    _createVNode(_component_el_dialog, {
      title: "物流详情",
      modelValue: _ctx.dialog.visible,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialog.visible) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_OrderTravel, {
          orderInfo: _ctx.dialog.orderInfo,
          "show-bill": "",
          loading: _ctx.dialog.loading
        }, null, 8, ["orderInfo", "loading"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}